import axios, { AxiosError } from 'axios';
import { Environment } from '../../../../environment';
import { Apiestoque } from '../../estoque/axiosestoque';

export interface IListagemRecebimento {
  idtransferencia: string;
  dataenvio: Date;
  datalan: Date;
  origem: string;
  portador: string;
}

export interface IDetalheRecebimento {
  iditens: string;
  qtdentrada: number;
  conversor: number;
  un: string;
  descricao: string;
  referencia: string;
  validade: Date;
}

type TotalCount = {
  data: IListagemRecebimento[];
  totalCount: number;
}

type TotalCountDia = {
  data: IDetalheRecebimento[];
  totalCount: number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}


const getAll = async (page = 1): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/transferenciarecebimento?page=${page}&limit=${Environment.LIMITE_DE_LINHAS}`;

    const { data, headers } = await Apiestoque.get(urlRelativa);

    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
 
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const getById = async (page = 1, id: string): Promise<TotalCountDia | Error> => {
  try {
    const urlRelativa = `/transferenciarecebimento/${id}?page=${page}&limit=1000`;

    const { data, headers } = await Apiestoque.get(urlRelativa);

    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
 
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const confirmar = async (id: string, status: number): Promise<void | Error> => {
  try {
    const dadosConfirmar = {status: status, datarecebimento: new Date()};
    await Apiestoque.put(`/transferenciarecebimento/${id}`, dadosConfirmar);

  } catch (error) {

    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const ConfirmarRecebimento = {
  getAll,
  getById,
  confirmar,
};